<template>
    <div class="modal">
        <div class="modal-dialog">
            <form @submit.prevent="saveUserRolesChanges" class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"> Asignar roles al usuario [<b>{{ selectedUserName }}</b>] </h5>
                    <button type="button" class="close" @click="closeModal">&times;</button>
                </div>
                <div v-if="isLoading" style="padding: 5ch 0;">
                    <SpeenComponent  
                        :isAutomatic="true" 
                        :ringWidth="14" 
                        :spinnerSize="15" 
                        :isverticalAligned="true"
                    />
                </div>
                <div v-else>
                    <div class="modal-body">
                        <div class="form-group">
                            <div class="form-check form-switch" 
                                v-for="role in roles" 
                                    :key="role" style="margin-bottom: 0.5rem;">
                                <input class="form-check-input" type="checkbox" 
                                    :id="`role-${role}`" :value="role" v-model="selectedRoles"/>
                                <label class="form-check-label" :for="`role-${role}`" 
                                    style="cursor: pointer; margin-left: 10px;">
                                    {{ role }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn btn-danger me-2" @click="closeModal">Cancelar</button>
                        <button type="submit" class="btn btn-success">Guardar</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import SpeenComponent from '../../common/components/SpeenComponent.vue';

export default {
    name: 'EditUserRolesModal',
    components: {
        SpeenComponent,
    },
    props: {
        selectedUserId: {
            type: Number,
            required: true
        },
        selectedUserName: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            selectedRoles: [],
            rolesData: [],
            isLoading: true,
        }
    },
    methods: {
        saveUserRolesChanges() {
            axios.put(`/api/user/${this.selectedUserId}/update-roles`, {roles: this.selectedRoles})
                .then(response => {
                    showCustomSuccessSweetAlert('Roles actualizados correctamente');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        getRoles(){
            axios.get('/api/roles')
                .then(response => {
                    this.rolesData = response.data.map(role => role.name);
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },        
        getUserRoles(){
            axios.get(`/api/user/${this.selectedUserId}/get-roles-and-permission-packages`)
                .then(response => {
                    this.selectedRoles = response.data.roles.map(role => role.name);
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        closeModal() {
            this.$emit('close-modal');
        },
    },
    computed: {
        roles() {
            return this.rolesData.filter(r => r.toLowerCase() !== 'superadmin')
        },
    },
    mounted() {
        this.getRoles();
        this.getUserRoles();
    },
}
</script>